'use client';

import EmptyList from '@/components/shop/empty-list';
import ShopItem from '@/components/shop/shop-item';
import { fetchShopList } from '@/lib/api/fetch-shop-list';
import { Languages } from '@/lib/dictionaries';
import { RootState } from '@/lib/store';
import { IShop } from '@/schema/shop';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import classes from './shop-list.module.scss';

function ShopList({
  lang,
  dict: { emptyIngList, emptyEndList },
  initialShops,
}: {
  lang: Languages;
  dict: {
    emptyIngList: string;
    emptyEndList: string;
  };
  initialShops: IShop[];
}) {
  const shopTabName = useSelector((state: RootState) => state.shop.tabName);
  const sortTabName = useSelector((state: RootState) => state.shop.sortOrder);
  const searchKeyword = useSelector(
    (state: RootState) => state.shop.searchKeyword,
  );

  const [shops, setShops] = useState<IShop[]>(initialShops);

  useEffect(() => {
    fetchShopList(shopTabName, sortTabName, searchKeyword).then(
      (shops: IShop[]) => setShops(shops),
    );
  }, [shopTabName, sortTabName, searchKeyword]);

  if (shops.filter((shop) => !shop.webHide).length === 0) {
    return (
      <EmptyList
        dict={{
          empty: shopTabName === 'ing' ? emptyIngList : emptyEndList,
        }}
      />
    );
  }

  return (
    <article className={classes.itemListLayout1}>
      <div className={classes.listWrap}>
        <ul>
          {shops.length > 0 &&
            shops.map((shop, index) => {
              if (shop.webHide) {
                return null;
              }
              return (
                <ShopItem lang={lang} shop={shop} index={index} key={shop.id} />
              );
            })}
        </ul>
      </div>
    </article>
  );
}

export default ShopList;
